// Core
import React, {useContext} from "react"

// Context
import { Context } from "../../context"

// Styles
import styles from "./audioToggle.module.scss"

const AudioToggle = ({ open, event }) => {
  const [state, setState] = useContext(Context)

  const setPlayAudio = (playAudio) => {
    setState(state => ({ ...state, playAudio: playAudio }))
  }

  return (
    <div
      className={`${styles.audioToggle} ${state.playAudio ? styles.audioActive : styles.audioInactive} flex`}
      aria-label={"Toggle Audio"}
      >
        <button onClick={() => setPlayAudio(true)}>Listen</button>
        <div onClick={() => setPlayAudio(!state.playAudio)} className={styles.switch}></div>
        <button onClick={() => setPlayAudio(false)}>Read</button>
    </div>
  )
}

export default AudioToggle